import classNames from 'classnames'
import { getPbgidIcon, usePbgidIcons } from '../helpers/pbgidIcons'

export function BonusShowcase({ icon, name }) {
	const pbgidIcons = usePbgidIcons()
	const _icon = typeof icon === 'number' ? getPbgidIcon(pbgidIcons, icon) || '/liveGameIcons/unknown.png' : icon

	return (
		<div className={classNames('bonusShowcase flex flex-row ')}>
			<div
				className="bonusShowcase__icon"
				style={{
					backgroundRepeat: 'no-repeat',
					backgroundSize: '100% 100%',
					backgroundImage: `url(/Empty_Background.png)`,
				}}>
				<img className="w-10 h-10" src={_icon} alt="" />
			</div>
			<h1 className="bonusShowcase__name">{name}</h1>
		</div>
	)
}
